<template>
  <span v-if="truncate && plainText.length > truncate">{{ plainText | truncate(truncate) }}</span>
  <span v-else-if="compactHtml !== null" class="rich-text rich-text--inline" v-html="compactHtml"></span>
  <div v-else class="rich-text" v-html="html"></div>
</template>

<script>
import { richTextToHtml, richTextToPlainText } from './richText';

// Shows a management statement or system description (US 9394) with its headers, lists and formatting.
// Task text fields use it without headers and compact: a text without lists shows as lines, as before.
// With truncate, a long text is shortened as plain text.
export default {
  name: 'RichTextView',
  props: {
    value: {
      type: String,
      default: ''
    },
    headings: {
      type: Boolean,
      default: true
    },
    compact: {
      type: Boolean,
      default: false
    },
    truncate: {
      type: Number,
      default: 0
    }
  },
  computed: {
    options() {
      return { headings: this.headings ? undefined : false, compact: this.compact };
    },
    // richTextToHtml rebuilds the text from the allowed tags only, so nothing else reaches the page
    html() {
      return richTextToHtml(this.value, this.options);
    },
    // A compact text without lists is inline (it's often inside a <p>), otherwise null
    compactHtml() {
      return this.compact && !/<(ul|ol|p|h2|h3)[\s>]/.test(this.html) ? this.html : null;
    },
    plainText() {
      return richTextToPlainText(this.value, this.options);
    }
  }
};
</script>
